const TELEPHONE = {
  href: 'tel:+34961923292 ',
  number: '961 923 292'
}

const DEFAULT = 'default'

const COMPLAINTS_URL = 'https://ATMV.gva.es/va/informacio-per-a-l-usuari/contacte'

/*
const SOCIAL_MEDIA = [
  {
    scope: DEFAULT,
    rrss: []
  }
]
*/
const SOCIAL_MEDIA = [
  {
    name: 'Twitter',
    icon: 'twitter',
    link: 'https://www.twitter.com/GVAatmv/'
  }
//    ,
//    {
//      name: 'Youtube',
//      icon: 'youtube',
//      link: 'https://www.youtube.com/watch?v=iz9z0LzpNdU'
//    },
//    {
//      name: 'Facebook',
//      icon: 'facebook',
//      link: 'https://www.facebook.com/ATMV'
//    },
//
//    {
//      name: 'Instagram',
//      icon: 'instagram',
//      link: 'https://www.instagram.com/ATMV/'
//    }
]
const ADDRESS = null

const EMAIL_ADDRESS = {
  username: 'atmv.sumat',
  domain: 'gva.es'
}

const GENERAL_TRANSPORT_CONDITIONS_URL = 'https://ATMV.gva.es/documents/165949857/167948389/Reglamento+CE+1370_2007+sobre+los+servicios+p%C3%BAblicos+de+transporte+de+viajeros+por+ferrocarril+y+carretera.pdf/b561bff4-0f7f-4198-86e9-3b0465268bb9'

export {
  TELEPHONE,
  COMPLAINTS_URL,
  SOCIAL_MEDIA,
  ADDRESS,
  EMAIL_ADDRESS,
  GENERAL_TRANSPORT_CONDITIONS_URL,
  DEFAULT
}
